<template>
    <div class="sa-flexbox" style="padding-bottom: 20px">
        <div class="sa-flexbox-header">
            <sa-filter-component @submit="onSubmit" @reset="onReset">
                <b-form>
                    <b-row class="sa-form-btn-filter">
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" v-if="!isPazienteMenu">
                            <label class="sa-label-data">Cognome:</label>
                            <input class="sa-page-search-component-input" v-model="filtroRiepilogoAccessoAdi.cognome" placeholder="Inserisci cognome..." />
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" v-if="!isPazienteMenu">
                            <label class="sa-label-data">Nome:</label>
                            <input class="sa-page-search-component-input" v-model="filtroRiepilogoAccessoAdi.nome" placeholder="Inserisci nome..." />
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" v-if="!isPazienteMenu">
                            <label class="sa-label-data">Codice identificativo:</label>
                            <input class="sa-page-search-component-input" v-model="filtroRiepilogoAccessoAdi.codiceIdentificativo" placeholder="Inserisci codice identificativo..." />
                        </b-col>

                        <b-col cols="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Data inizio:</label>
                            <div class="sa-page-search-component-wrapper" style="flex: 1; min-width: 70px">
                                <date-picker class="sa-date-like-input" input-class="sa-page-search-component-input" format="DD-MM-YYYY" value-type="timestamp" v-model="filtroRiepilogoAccessoAdi.dataOraInizio" type="date" placeholder="Inserisci Data" />
                            </div>
                        </b-col>

                        <b-col cols="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Data fine:</label>
                            <div class="sa-page-search-component-wrapper" style="flex: 1; min-width: 70px">
                                <date-picker class="sa-date-like-input" input-class="sa-page-search-component-input" format="DD-MM-YYYY" value-type="timestamp" v-model="filtroRiepilogoAccessoAdi.dataOraFine" type="date" placeholder="Inserisci Data" />
                            </div>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <div class="sa-page-search-component-input-group" style="flex: 1; min-width: 70px">
                                <label class="sa-label-data">Stato</label>

                                <select class="sa-prescrizione-input sa-select-flex" v-model="filtroRiepilogoAccessoAdi.stato">
                                    <option :value="null">-Seleziona Valore-</option>
                                    <option v-for="item in riepilogoAccessiStatoOptions" :key="item.id" :value="item.value" value-field="value">
                                        {{ item.descrizione }}
                                    </option>
                                </select>
                            </div>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" v-if="!isPazienteMenu">
                            <label class="sa-label-data">Cognome operatore:</label>
                            <input class="sa-page-search-component-input" v-model="filtroRiepilogoAccessoAdi.cognomeOperatore" placeholder="Inserisci cognome operatore..." />
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" v-if="!isPazienteMenu">
                            <label class="sa-label-data">Nome operatore:</label>
                            <input class="sa-page-search-component-input" v-model="filtroRiepilogoAccessoAdi.nomeOperatore" placeholder="Inserisci nome operatore..." />
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" v-if="!isPazienteMenu">
                            <label class="sa-label-data">Profilo operatore:</label>
                            <input class="sa-page-search-component-input" v-model="filtroRiepilogoAccessoAdi.profilo" placeholder="Inserisci profilo operatore..." />
                        </b-col>
                    </b-row>
                </b-form>
            </sa-filter-component>
        </div>
        <div class="sa-flexbox-footer" style="background-color: ciano; padding-top: 0.5rem">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <div class="sa-flexbox-body">
            <div class="b-table-sticky-header">
                <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="visibleFields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                    <template v-slot:cell(nominativo)="{ item }">
                        <span>
                            <b>{{ item.cognome }} {{ item.nome }}</b></span
                        >
                        <br />
                        <span>{{ item.identificativo }} </span>
                    </template>
                    <template v-slot:cell(dataOraInizio)="{ item }">
                        <span>{{ formatDateTime(item.dataOraInizio) }}</span>
                    </template>
                    <template v-slot:cell(dataOraFine)="{ item }">
                        <span>{{ formatDateTime(item.dataOraFine) }}</span>
                    </template>

                    <template v-slot:cell(operatoreNomeCognome)="{ item }">
                        <span>{{ item.cognomeOperatore }} {{ item.nomeOperatore }} </span>
                        <br />
                        <span> {{ item.profilo }}</span>
                    </template>
                    <template v-slot:cell(actions)="row">
                        <b-container class="bv-example-row">
                            <b-button size="sm" v-b-tooltip.hover title="Info" variant="outline-secondary" @click="onClickVisualizzaAttivita(row)" :disabled="row.item.numeroPrestazioni === 0">
                                <font-awesome-icon icon="info-circle"></font-awesome-icon>
                            </b-button>
                        </b-container>
                    </template>
                    <template #row-details>
                        <div class="sa-table-row-details">
                            <b-table sticky-header stacked="lg" striped hover :items="itemsAttivita" :fields="fieldsAttivita" sort-icon-left head-variant="light" class="sa-b-table">
                                <template v-slot:cell(indicazioni)="{ item }">
                                    <span v-html="item.indicazioni"> </span>
                                </template>
                                <template v-slot:cell(dataOraPrevista)="{ item }">
                                    <span>{{ formatDateTime(item.dataOraPrevista) }}</span>
                                </template>
                                <template v-slot:cell(dataOraEffettuata)="{ item }">
                                    <span>{{ formatDateTime(item.dataOraEffettuata) }}</span>
                                </template>
                            </b-table>
                        </div>
                    </template>
                </b-table>
            </div>
        </div>
    </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import UtilityMixin from "../../../utility/UtilityMixin";
import SaFilterComponent from "../../../../template/layout/components/SaFilterComponent.vue";
export default {
    props: {
        idAccettazione: { type: String, default: null },
    },
    mixins: [UtilityMixin],
    components: {
        DatePicker,
        SaFilterComponent,
    },
    computed: {
        visibleFields() {
            return this.fields.filter((field) => field.visible);
        },
    },
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            isPazienteMenu: false,
            rigaAttualeAperta: null,
            filtroRiepilogoAccessoAdi: { cognome: null, nome: null, stato: null, dataOraInizio: null, dataOraFine: null, identificativo: null, nomeOperatore: null, cognomeOperatore: null, profilo: null },
            items: [],
            riepilogoAccessiStatoOptions: [
                { value: "APERTO", descrizione: "APERTO" },
                { value: "CHIUSO", descrizione: "CHIUSO" },
            ],
            listKey: 0,
            pathResource: "/rsaadiaccessi/riepilogo",
            pathResourceAdiAccessi: "/rsaattivitapazienti",
            rigaSelezionata: {},
            fields: [
                {
                    label: "Cognome/Nome",
                    key: "nominativo",
                    sortable: false,
                    visible: !this.isPazienteMenu,
                },
                {
                    label: "Data/ora Inizio",
                    key: "dataOraInizio",
                    sortable: true,
                    visible: true,
                },
                {
                    label: "Data/ora Fine",
                    key: "dataOraFine",
                    sortable: true,
                    visible: true,
                },
                {
                    label: "Stato",
                    key: "stato",
                    sortable: false,
                    visible: true,
                },

                {
                    label: "Operatore",
                    key: "operatoreNomeCognome",
                    sortable: false,

                    visible: true,
                },
                {
                    label: "N. Attività",
                    key: "numeroPrestazioni",
                    sortable: false,
                    visible: true,
                },
                { class: "sa-table-column-action-double", key: "actions", label: "", visible: true },
            ],
            itemsAttivita: [],
            fieldsAttivita: [
                {
                    label: "Indicazioni",
                    key: "indicazioni",
                },
                {
                    label: "Note",
                    key: "note",
                },

                { label: "Stato", key: "stato" },
                {
                    label: "Data/Ora prevista",
                    key: "dataOraPrevista",
                },
                {
                    label: "Data/ora effettuata",
                    key: "dataOraEffettuata",
                },
            ],
        };
    },
    mounted() {
        let me = this;
        let sessionStorage = window.sessionStorage;
        if (sessionStorage["filtroRiepilogoAccessoAdi"]) {
            me.filtroRiepilogoAccessoAdi = JSON.parse(sessionStorage["filtroRiepilogoAccessoAdi"]);
        } else {
            sessionStorage["filtroRiepilogoAccessoAdi"] = JSON.stringify(me.filtroRiepilogoAccessoAdi);
        }
    },
    watch: {
        currentPage() {
            let me = this;
            me.init();
        },
        "filtroRiepilogoAccessoAdi.dataOraInizio"(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.onSubmit();
            }
        },
        "filtroRiepilogoAccessoAdi.dataOraFine"(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.onSubmit();
            }
        },
        "filtroRiepilogoAccessoAdi.stato"(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.onSubmit();
            }
        },
    },
    methods: {
        init(isPazienteMenu) {
            let me = this;
            me.isPazienteMenu = isPazienteMenu;
            me.fields[0].visible = !isPazienteMenu;
            me.loadData();
        },
        setPazienteMenu(isPaziente) {
            let me = this;
            me.isPazienteMenu = isPaziente;
        },
        loadData() {
            let me = this;
            me.$emit("beforeLoadData");
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroRiepilogoAccessoAdi"] = JSON.stringify(me.filtroRiepilogoAccessoAdi);
            if (me.idAccettazione) {
                let filtro = me.filtroRiepilogoAccessoAdi;
                filtro.idAccettazione = me.idAccettazione;
                filtro.cognome = null;
                filtro.nome = null;
                filtro.identificativo = null;
                UtilityMixin.methods.loadDataResources(me.pathResource, filtro, me.loadDataSuccess, me.loadDataError);
            }
            UtilityMixin.methods.loadDataResources(me.pathResource, me.filtroRiepilogoAccessoAdi, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
            me.listKey++;
            me.$emit("afterLoadData", me.items);
        },
        loadDataError(error) {
            let me = this;
            me.showModalLoading = false;
            console.log("errore response", error);
        },
        onReset() {
            let me = this;
            me.filtroRiepilogoAccessoAdi = { cognome: null, nome: null, stato: null, dataOraInizio: null, dataOraFine: null, identificativo: null, nomeOperatore: null, cognomeOperatore: null, profilo: null };
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroRiepilogoAccessoAdi"] = JSON.stringify(me.filtroRiepilogoAccessoAdi);
            me.loadData();
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroRiepilogoAccessoAdi"] = JSON.stringify(me.filtroRiepilogoAccessoAdi);
            me.loadData();
        },
        onClickVisualizzaAttivita(row) {
            let me = this;
            if (me.rigaAttualeAperta && me.rigaAttualeAperta.item.id === row.item.id) {
                row.toggleDetails();
                me.rigaAttualeAperta = null;
                return;
            }
            if (me.rigaAttualeAperta) {
                me.rigaAttualeAperta.toggleDetails();
            }

            me.loadAttivita(row);
            row.toggleDetails();
            me.rigaAttualeAperta = row;
        },
        loadAttivita(row) {
            let me = this;
            me.itemsAttivita = [];
            me.rigaSelezionata = row.item;
            UtilityMixin.methods.loadDataResources(me.pathResourceAdiAccessi, { idAccesso: row.item.id }, me.loadAttivitaSuccess, me.loadAttivitaError);
        },
        loadAttivitaSuccess(response) {
            let me = this;
            me.itemsAttivita = response.data.data.list;
        },
        loadAttivitaError(response) {
            console.log("errore response", response);
        },
        resetFiltroRiepilogoAccessoAdi() {
            let me = this;
            me.filtroRiepilogoAccessoAdi = {
                cognome: null,
                nome: null,
                stato: null,
                dataOraInizio: null,
                dataOraFine: null,
                identificativo: null,
                nomeOperatore: null,
                cognomeOperatore: null,
                profilo: null,
            };
            me.init();
        },
    },
};
</script>
<style scoped>
.sa-date-like-input,
.sa-date-like-input .mx-datepicker,
.sa-date-like-input .mx-input-wrapper {
    width: 100% !important;
}

.sa-date-like-input .mx-input {
    background: transparent !important;
}

.sa-date-like-input >>> .mx-icon-calendar,
.sa-date-like-input >>> .mx-icon-clear {
    display: none !important;
}

.sa-date-like-input .mx-input {
    padding-right: 10px !important;
}
.sa-page-search-component-wrapper {
    display: flex;
    width: 100%;
    align-items: center;
    gap: 6px;
}

.sa-page-search-component-input {
    width: 100%;
    flex: 1 1 auto;
}
.sa-page-search-component > .row {
    flex: 1 1 auto;
    width: 100%;
}
</style>
